import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    imgs: {
      type: Array,
      required: true,
    },
    showThumbnails: {
      type: Boolean,
      default: true,
    },
    showControllers: {
      type: Boolean,
      default: false,
    },
    mobileControllers: {
      type: Boolean,
      default: false,
    },
    borderRadius: {
      type: Boolean,
      default: false,
    },
    fullHeight: {
      type: String,
      default: '',
    },
    doubleCarousel: {
      type: Boolean,
      default: false,
    },
    isTravel: {
      type: Boolean,
      default: false,
    },
  },
})
export default class ActivityCarouselComponent extends Vue {
  coverIndex = 0;
  slideShow = false;

  mounted() {
    if (this.showControllers === false) {
      this.nextImageTransition();
    }
  }

  getCurrentCover() {
    return this.imgs[this.coverIndex];
  }

  nextImageTransition() {
    this.nextImageTimeout = setTimeout(() => {
      this.goToNextImage();
    }, 2000);
  }

  goToNextImage() {
    this.coverIndex += 1;
    if (this.coverIndex >= this.imgs.length) {
      this.coverIndex = 0;
    }
    clearTimeout(this.nextImageTimeout);

    if (!this.showControllers) {
      this.nextImageTransition();
    }
  }

  goToPrevImage() {
    if (this.coverIndex === 0) {
      this.coverIndex = this.imgs.length - 1;
    } else {
      this.coverIndex = this.coverIndex - 1;
    }

    clearTimeout(this.nextImageTimeout);

    if (this.showControllers === false) {
      this.nextImageTransition();
    }
  }

  goToImage(index) {
    this.coverIndex = index;
    this.getCurrentCover();
  }

  /* toggleSlideShow() {
    this.slideShow = !this.slideShow;
    if (this.slideShow) {
    clearTimeout(this.nextImageTimeout);
    } else {
      this.nextImageTransition();
    }
  } */
}
